export const pilotPromptExamples = [
    "Every Monday, pull last week's closed deals from HubSpot and post a summary to #sales in Slack.",
    "When a Typeform response comes in, add the lead to Salesforce and email the account owner.",
    "Turn invoices that land in Gmail into bills in QuickBooks and file the PDF in Google Drive.",
    "Ping #fulfillment in Slack when a Shopify order has not shipped after two days.",
    "Copy new Calendly bookings into Google Sheets and create a follow-up task in Asana."
]

export interface PilotStep {
    id: string
    lead: string
    text: string
}

export const pilotSteps: Array<PilotStep> = [
    {
        id: 'connect',
        lead: "Connect your apps.",
        text: "Real work moves across lots of tools. Give Pilot access to all of them so she sees the whole picture."
    },
    {
        id: 'teach',
        lead: "Teach Pilot to work between them.",
        text: "Every job has its own rhythm. Show her the steps, choices and details that make it yours."
    },
    {
        id: 'automate',
        lead: "Automate that work.",
        text: "Pilot turns your process into a real workflow that runs on its own, with no code and no technical handoff."
    }
]

export const clusterApps = [
    "Gmail",
    "Slack",
    "HubSpot",
    "Google Sheets",
    "Notion",
    "Shopify",
    "Zendesk",
    "Google Calendar"
]

export interface FlowStep {
    id: string
    app: string
    text: string
}

export const flowSteps: Array<FlowStep> = [
    { id: 'trigger', app: "Shopify", text: "When a new wholesale order arrives" },
    { id: 'lookup', app: "HubSpot", text: "Look up the buyer's account and owner" },
    { id: 'stock', app: "NetSuite", text: "Check stock across every warehouse" },
    { id: 'notify', app: "Slack", text: "Post a summary to #fulfillment" }
]
